import type { BreadcrumbConfig } from "@/config/documentViewConfig";

/** Keep the entry root visible; collapse middle hops into ellipsis when over maxVisible. */
export const collapseBreadcrumbParents = (
  parents: BreadcrumbConfig[],
  maxVisible = 2
): BreadcrumbConfig[] => {
  if (parents.length <= maxVisible) {
    return parents;
  }

  if (maxVisible <= 0) {
    if (parents.length <= 1) {
      return parents;
    }

    return [
      parents[0],
      {
        title: "…",
        url: "#",
        kind: "ellipsis",
        hiddenParents: parents.slice(1),
      },
    ];
  }

  const tailCount = Math.max(1, maxVisible - 1);
  const hiddenParents = parents.slice(1, -tailCount);

  if (hiddenParents.length === 0) {
    return [...parents.slice(0, 1), ...parents.slice(-tailCount)];
  }

  return [
    parents[0],
    {
      title: "…",
      url: "#",
      kind: "ellipsis",
      hiddenParents,
    },
    ...parents.slice(-tailCount),
  ];
};
